<template>
  <page-view hide-navigation>
    <in-viewport>
      <content-section
        :widgets="detailsWidgets"
        :visible="visible"
        @transitionEnd="setWidgets"
      />
    </in-viewport>
    <in-viewport>
      <footer-section
        :heading="$t('info')"
        :team1="details.team1"
        :description="details.team2"
      />
    </in-viewport>
    <in-viewport><details-pagination-container/></in-viewport>
  </page-view>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { SET_CURRENT_PROJECT } from '@/store/mutation-types'
import ContentSection from '@/containers/Details/ContentSection'
import FooterSection from '@/containers/Details/FooterSection'
import DetailsPaginationContainer from '@/containers/DetailsPaginationContainer'

export default {
  components: {
    ContentSection,
    FooterSection,
    DetailsPaginationContainer
  },
  data () {
    return {
      visible: true,
      detailsWidgets: []
    }
  },
  computed: {
    ...mapGetters(['details']),
    widgets () {
      const { widgets = [], title, description, team1, team2 } = this.details
      return [{ type: 'text', title, description, team1, team2 }, ...widgets]
    }
  },
  watch: {
    widgets () {
      if (this.detailsWidgets.length && this.visible) {
        this.visible = false
      } else {
        this.setWidgets()
      }
    },
    '$route.params.id' () {
      this.setProject()
    }
  },
  created () {
    this.setProject()
  },
  beforeDestroy () {
    this.setCurrentProject(-1)
  },
  methods: {
    ...mapMutations({ setCurrentProject: SET_CURRENT_PROJECT }),
    setWidgets () {
      this.detailsWidgets = this.widgets

      this.$nextTick(() => {
        this.visible = true
      })
    },
    setProject () {
      const { params = {} } = this.$route
      this.setCurrentProject(parseInt(params.id))
      this.setWidgets()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Details/DetailsContainer.vue